<template>
  <!-- Start MCT breadcrumb section -->
  <BreadCrumb ImageUrl="/assets/images/shapes/header-bg-5.png" PageName="サービス" :PageLink="pageLink" :SubName="data.title"/>
  <!-- End MCT breadcrumb section -->
  <!-- Start reinfo_breadcrumb section -->
    <!-- Start reinfo_breadcrumb section -->
  <section class="auninfo_contact cantact_v2 section_padding" style="margin-top:50px">
    <div class="container">
       <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
            <p><span>{{data.english}}</span></p>
        </div>
        <component :is="currentTab" class="cantact_box_margin_top"></component>
      </div>
  </section>

  <img src="/assets/images/shapes/bg-shape-1-2.png" class="error-404__bg-shape-2" alt="">
  <img src="/assets/images/shapes/bg-shape-1-3.png" class="error-404__bg-shape-3" alt="">

  <div class="error-404__bubble-1"></div>
  <!-- /.error-404__bubble-1 -->
  <div class="error-404__bubble-2"></div>
  <!-- /.error-404__bubble-2 -->
  <div class="error-404__bubble-3"></div>
  <!-- /.error-404__bubble-3 -->
  <div class="error-404__bubble-4"></div>
  <!-- /.error-404__bubble-4 -->
  <div class="error-404__bubble-5"></div>
  <!-- /.error-404__bubble-5 -->
  <div class="error-404__bubble-6"></div>
  <!-- /.error-404__bubble-6 -->
  <div class="error-404__bubble-7"></div>
  <!-- /.error-404__bubble-7 -->
  <div class="error-404__bubble-8"></div>
  <section style="margin-bottom:50px">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="single_blog_wrapper" data-aos="fade-right" :data-aos-duration="500">
            <div class="post_content" v-html="data.content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
import BreadCrumb from "../components/BreadCrumb";
import { onMounted,ref,watch } from '@vue/runtime-core'
import { useRoute } from "vue-router";
export default {
  name: "Service",
  components:{ BreadCrumb },
  setup() {
    const route = useRoute();
    const serviceList = {
          Development: {
            title: 'システム開発',
            english: 'Development',
            content:
              '<h2>システム開発業務支援概要及び対応領域</h2><p>MCTがグローバルに連携し、円滑なプロジェクト推進を実現するとともに、上流設計⇒製造・単体テスト⇒結合テスト工程に至るまでのトータルサポートをご提供する体制が整っております。　金融、通信、公共・医療、製造・物流の領域における、システムコンサルティングから設計・構築・運用・保守に至るまで、より高品質なトータル･ソリューションサービスを世界各国のサイトよりご提供いたします。</p><br /><br /><h2>主な業務実績</h2><p><img style="width:80%" src="/assets/images/service/0/1.jpg"></p>'
          },
          Embedded : {
          title: '組込開発',
          english: 'Embedded',
          content:
            '<h2>豊富な組込製品開発実績により質の良いサービス提供をお約束します</h2><p>近年、組込機器におけるIoT化の普及とともに多機能化が進み、開発は複雑化し、より重要度が上がっております。我社は各種通信機器をはじめとした豊富な開発経験により、お客様の事業フェーズに合わせた最適なソリューションをご提供するとともに、高品質技術の提供をお約束いたします。</p><p><br></p><p>組み込みソフト開発は、家庭用、産業用を問わず電子制御を必要とする製品に用いられます。</p><p>例えばデジタル家電（炊飯器、洗濯機、電話機デジタルカメラなど）、輸送機器（自動車のエンジンコントロールユニット、カーナビ、航空機、鉄道車両など）、また医療の世界でも自動血圧計や心電計除細動器（AED）などにも使用されています。<br />こちらも業務用と同様アセンブリ言語の知識が必要とされます</p><br /><p></p><p>弊社は自動車カーナビについて、複数要員が大手組込系に常駐して開発を支援しています。</p>'
        },
        DataMigration:{
          title: 'データ移行',
          english: 'Data migration',
          content:
            '<p>「データを、ある場所からある場所に移すこと」で、データマイグレーション（data migration）とも言われます。</p><p>基幹システムの更改で旧システムから新システムへの移行を行う際、最大の難関が「データ移行」と言われています。しかし、入れ物となる仕組みには費用・スケジュール・稼働が確保されていたとしても、データ移行については予算外の扱いであったり、十分に工数が考慮がされていないケースも少なくありません。リアライズは豊富な実績と経験から、成功のポイントを確実に抑えたソリューションをご提供します。</p><p><br></p><p>&nbsp;・設計からデータ移行の実施まで</p><p>設計からデータ移行の実施まで視野に入れた総合ソリューション<br />システム開発の設計段階から参画をすることで、計画的かつ明確なシナリオに基づき、データ移行を進めることが可能です。テスト・リハーサル・本番などの開発スケジュールを踏まえた上で、移行完了まで責任をもってご支援します。</p><p>・データ視点に基づき、データ移行の落とし穴を回避</p><p>データ移行の計画、遂行時に必ず押さえたい基本的な事柄から、手順や段取り面でのポイント、陥りやすい注意点を押さえたご提案をします。システム開発の視点だけでは見落としがちな設計・作業に対し、データ視点から着実にご支援します。</p><p>・ データ移行ソリューションの組み合わせ例</p><p>現状データ調査＋移行方針策定（計画書・手順書）＋データクレンジング＋名寄せ（数回実施）＋データ移行作業支援</p><br /><p><img style="width:80%" src="/assets/images/service/2/1.jpg"></p>'
        },
        Blockchain:{
          title: 'ブロックチェーン',
          english: 'Blockchain',
          content:
            '<h2>業務性質や顧客ニーズにマッチした効率的なブロックチェーン技術の導入</h2><p>当社は、今後の市場におけるブロックチェーンの拡大を視野に入れ、今日に至るまでに多くの研究開発に時間を費やしてきました。 金融取引における活用が注目されがちなブロックチェーン技術ですが、当社はあらゆるシーンへの活用を想定し、 日々ソリューション開発を進めております。 研究開発の技術的方向は、スマートコントラクト、コンソーシアムチェーン、分散型暗号化ストレージ等となり、 対象業種は、銀行業、保険業、金融業、物流領域等です。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/3/1.jpg"></p><p>ブロックチェーンの最大のメリットは安全性の高さです。取引ごとに暗号化した署名を用いるため、なりすまし行為が困難となることに加え、取引データは過去のものと連鎖して保存されているため、万が一データの一部を改ざんしても過去のデータもすべて改ざんしなければ整合性が取れなくなります。<br />更に、外部からでも台帳を用いて過去のデータを参照することができるため、データの改ざんをリアルタイムで監視可能になっています。そのため改ざんはほぼ不可能と言えます。</p><p><p></p></p><p>また、もうひとつのメリットは「低コストである」ということです。あらゆる取引では、基本的に仲介役を立てることで安全な取引をする場合が多く、仲介手数料が発生しますが、ブロックチェーンのシステムを用いれば仲介役がなくとも安全な取引が行えるため、仲介手数料が発生しなくて済むことも注目されています。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/3/2.jpg"></p>'
        },
        AI:{
          title: '人工知能',
          english: 'AI',
          content:
            '<h2>ビッグデータを活用した各種エンジン開発に加え、検知・検出・判断で利用</h2><p>AIテクノロジーが画期的な進歩を遂げる中、我社はより身近な視点からAIの活用を提案すべく、鋭意開発を進めております。 人工知能における最先端技術と我社が長年にわたって蓄積してきた金融業における業務経験とを結合し、人工知能の各種金融領域における応用の幅を広め、 かつ新しい応用技術の開発の促進を目的としています。 同時に、自動化された人工知能（画像認識、文字認識、データ発掘等）の能力を向上させ、 それを基にして人工知能時代における新金融人工知能製品開発を進めております。</p><p>AIは幾つかの種類に分類することができ、それぞれに特徴を持っています。大別すると、特定の機能に特化したタイプと、対象を特定しない汎用型にカテゴリーを分けることができます。</p><p>特定型はある分野の問題解決に特化したスタイルをとっており、囲碁や将棋ではすでに人間の能力を凌駕する能力が実用化されているものもあり、自動車の自動運転技術やコールセンター業務の代替なども代表的事例と言えます。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/4/2.jpg"></p><br /><p>汎用型は特定のトピックにとらわれず多岐にわたる分野で問題の解決を可能とするプログラムです。人間のように自己制御や自省を行うことが可能で、設定時の想定領域外の事象に直面しても対応可能なプログラムとなっています。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/4/1.jpg" style="width:80%"></p>'
        },
        BigData:{
          title: 'ビッグデータ',
          english: 'Big data',
          content:
            '<h2>MCTにおけるビッグデータソリューション開発</h2><p>ビッグデータに関するソフトウェア・ミドルウェアの応用における製品化とビッグデータクラウドサービスの開発を推進し、 金融、通信、医療をはじめとした各業界向けにビッグデータ応用の実現へ向けた活動をしております。</p><br /><br /><p class="tc"></p>'
        },
        Smartphone:{
          title: 'スマホ・タブレット',
          english: 'Smartphone / Tablet',
          content:
            '<p>スマートデバイスは、フィールド業務で役立つ素晴らしいツールです。<br/>「パッ」と立ち上げて、「サッ」と確認して、<br/>「テキパキ」と入力。スマートデバイス・タッチUI専門のアプリ・システム開発チームが御社の“こんなことやりたい”を形にします。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/6/smartphone.png" /></p><br /><p>スマートフォン・タブレットなどのスマートデバイスを自社のビジネスシーンやフィールド業務の現場で活用したい<br/>企業様を対象としたフルオーダーメイドのアプリ・システム開発導入サービスです。<br/>豊富な経験と実績を元に、安心のサービスをご提供いたします。<br/>iPhone、iPad、Android、Windows タブレットなど、各種デバイスに対応可能です。<br/>OSネイティブアプリ、Webビューアプリ、ハイブリッドアプリなど、<br/>お客様のご予算とご要望に応じてご提案させて頂きます。<br/>もちろん、バックエンドのWebシステム開発、データベース構築もお任せください。<br/>'
        },
        CRM:{
          title: 'CRMシステム',
          english: 'CRM System',
          content:
            '<p>CRMシステムは、顧客管理システムとも呼ばれます。</p><br /><p class="tc"></p><br /><p>ユーザーの購買履歴やサイト閲覧履歴、フィードバックや営業情報などの顧客データをシステムを使って可視化・一元管理化します。<br />顧客のニーズに個別に、的確に対応して顧客満足度を上げ、マーケティングの効果を最大化すること、また、それを実現するためのシステム自体をCRMまたはCRMシステムといいます。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/6/original-crm1.jpg" /></p><br/><h2>営業支援機能</h2><p>商談、見積、成約の状況など営業担当者の行動管理を中心とした機能です。<br />この機能を利用して、営業担当者に顧客に対するアクションの指示を行うなど、効果の高い営業活動の実現を支援します。</p><h2>マーケティング支援機能</h2><p>キャンペーンの管理や顧客へのPRメールの配信など、効果的なマーケティング活動を支援する機能です。<br />行った施策と実際の顧客からの問い合わせや商談、受注状況を関連づけて管理・分析することで、効果の高いマーケティング活動を実現します。</p><h2>顧客サポート支援機能</h2><p>製品購入後の問い合わせやクレーム対応状況を管理する機能です。<br />この機能を利用することで自社が求められる顧客対応を迅速・確実に行い、顧客満足度向上に向けた取り組みを支援します。</p><h2>CRMシステムの活用</h2><p>オンラインゲームサイト運営<br />利用履歴やセグメント別会員情報の分析で新規会員増加<br />介護サービス事業者<br />利用者の声をモバイル端末でタイムリーにデータ化し分析に活用<br />上記に無い機能でも自由に開発が可能です。お気軽にお問い合わせください。</p>'
        },
        WebSystem:{
          title: 'WEBシステム',
          english: 'WEB System',
          content:
            '<p>Webシステムとは、簡単に言えばWebブラウザで閲覧するシステムの事です。</p><p>日頃、Webブラウザでは、ホームページを見ていると思いますが、Webブラウザでホームページの代わりにシステムを見るようになります。</p><p>Webブラウザが搭載されている機器、つまり、インターネットを見る事が出来る機器であれば、Windowsでも、Macでも、iPad、iPhone、Android、携帯電話でもWebシステムを使う事が基本的に出来ます。</p><p>システムが動作する仕組みはホームページで使用するのと同じ仕組みを使用します。</p><p>構成は、Webサーバ、データベースサーバ、そして、それらをアクセスするためのクライアント（コンピュータやタブレット端末、等）となります。</p><p>画面部分をWebサーバが担当し、データの保管をデータベースサーバが担当するため、クライアントは、Webブラウザを使用するだけとなり、クライアントへの負荷が少なく、また、クライアントへのソフトのインストールや面倒なセットアップを必要としない特徴があります。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/7/flow_phase.gif" /></p><br/><h2>Webシステム開発実績が豊富</h2><p>会員管理、ECサイト、SNS連動システム、業務システム構築など、複数のWebシステム開発実績があります。</p><p>スクラッチから既存システムのカスタマイズまで幅広く対応致します。</p><h2>最適なCMSをご提案・導入可能</h2><p>CMS構築・導入の実績で培ったノウハウをもとに、情報設計をドキュメント化し、お客様のWebサービスの目的を実現するCMSテンプレートの設計、開発を行います。</p><h2>ワンストップで課題を解決</h2><p>リサーチ・調査/マーケティング/企画/開発/検証/運用/マーケット申請の対応/プロモーション/効果測定などWebシステム開発の初期構築のみならず、サービス企画・運用・ユーザーサポートまで、一連のサービスを有機的に連携させることで価値最大化を実現します。</p>'
        },
        ManageSystem:{
          title: '管理システム',
          english: 'Manage System',
          content:
            '<p>お客様を中心とした情報系・勘定系・市場系システムにおける開発支援や、保守運用メンテナンス。</p><p>開発手順、開発環境であるフレームワークと開発支援ツール、開発をバックアップするサポートを一体としたトータルソリューションを提供しています。</p><p>現在のシステム開発は、ニーズの高度化や開発スケジュールの短縮化、日々進化する技術など多くの潜在的リスクを抱えています。</p><p>そうした開発現場におけるリスクを軽減するため、各種Webサイト向けのサービス基盤（サーバーとネットワーク、監視システム）の設計構築およびサービスイン後の保守対応、各種プラットフォームによるサーバ設計、構築・データベースの物理設計、論理設計及び構築・認証システムの設計、構築をおこないます。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/8/manage-sys.png" /></p><br/><h2>銀行システム開発</h2><p>創業以来、某都市銀行のシステム開発を中心に受託し、運用性預金・金融債・社債・情報系・経理・市場系等の受託実績を積んできました。</p><p>その後、市場変動に伴う新規金融商品の対応やグローバル対応に参画し、旧来の得意分野の対応に加え対応範囲を広めています。</p><p>また、極力お客様の声を聴けるよう、ユーザー部案件の受託等を行い、高い業務知識を維持した金融系集団を形成しております。</p><h2>クレジットカードシステム開発</h2><p>クレジットカードシステムにおける設計・開発および運用実績により培ったノウハウを活かした、お客様の業績向上に貢献するITサービスの提供を第一と考えております。</p><p>カード決済の軸となるオーソリや認証を中心として、国内外の各種カードネットワークとの接続、売上・請求システムとのI/Fなど、多岐にわたる業務システムの設計、開発、保守に携わっております。</p><p>また、アプリケーション面にとどまらず、クレジットカードシステムにおける運用基盤の構築・保守業務を通じて、お客様のシステム安定稼働や業務効率化に資する運用サービスも提供しております。</p>'
        },
        Consulting:{
          title: 'コンサルティング',
          english: 'Consulting',
          content:
            '<p>現状のシステムに対する非効率化の解消や新たに導入を計画されているシステムについて、分析・提案するコンサルティングを行っています。</p><br /><p class="tc"><img style="width:80%" src="/assets/images/service/9/commentary.png" /></p><br/>'
        }
    };
    const data = serviceList[route.params.id];
    const pageLink = ref('/service');
    return {data,pageLink}
  }
}
</script>
<style lang=""></style>
